<template>
  <div>
    <div class="left">
      <span> {{ $route.meta.title }}</span>
      <div class="right">
        <Button @click="back" style="margin-right: 20px">取消</Button>
        <Button type="primary" @click="save()">保存</Button>
      </div>
    </div>

    <Form
      ref="formInline"
      :model="info"
      :rules="rule"
      :label-width="100"
      inline
    >
      <FormItem prop="name" label="角色名称:">
        <Input
          v-model="info.name"
          placeholder="请输入角色名称"
          style="width: 250px"
        />
      </FormItem>
      <br />
      <FormItem label="权限控制:">
        <Row
          style="width: 1360px"
          class="col"
          v-for="(item, key) in PageData"
          :key="key"
        >
          <div class="group">
            <Poptip
              trigger="hover"
              title="小提示"
              content="如果只保留查看权限请保留下列“查看”选项"
              placement="top"
            >
              <Checkbox
                :value="item.checkAll"
                @click.prevent.native="handleCheckAll(key)"
                :indeterminate="item.indeterminate"
                style="color: #000"
                >{{ item.nameString }}</Checkbox
              >
            </Poptip>
          </div>
          <CheckboxGroup
            v-model="item.checkAllGroup"
            @on-change="checkAllGroupChange($event, key)"
          >
            <Checkbox
              v-for="(val, index) in item.functions"
              :key="index"
              :label="val.nameString"
              style="color: #aaa; margin-right: 100px"
            ></Checkbox>
          </CheckboxGroup>
          <div class="line"></div>
        </Row>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import page from "../../config/page_role";
let pages = [];
export default {
  data() {
    return {
      id: 0,
      info: {
        id: 0,
        shop_id: 0,
        name: "",
        functions: {},
      },
      rule: {
        name: [{ required: true, message: "请输入角色名称", trigger: "blur" }],
      },
      checkAllGroup: [],
      PageData: {},
      loading: false,
    };
  },
  created() {},
  mounted() {
    pages = [];
    for (let i in page) {
      pages.push(page[i]);
    }

    pages.map((item) => {
      item.checkAll = false;
      item.checkAllGroup = [];
      // item.functions.forEach(val => {
      //   val.status = true;
      //   item.checkAllGroup.push(val.nameString);
      // });
    });

    if (this.$route.params.id && this.$route.params.id > 0) {
      this.id = this.$route.params.id;
      this.GetInfo();
    } else this.PageData = pages;
  },
  methods: {
    ...mapActions(["GetRoleList", "SaveRole"]),
    GetInfo() {
      this.GetRoleList({ id: this.id }).then((res) => {
        let data = res.data[0];
        data.functions = data.functions ? JSON.parse(data.functions) : {};
        this.info = data;
        pages.map((item, index) => {
          if (!data.functions[item.name]) {
            item.functions.map((val, key) => {
              val.status = false;
            });
            item.checkAllGroup = [];
            item.checkAll = false;
          } else if (
            data.functions[item.name] &&
            data.functions[item.name].disabled
          ) {
            item.functions.map((val, key) => {
              val.status = false;
            });
            item.checkAllGroup = [];
            item.checkAll = false;
            item.indeterminate = false;
          } else {
            let a = [];
            item.checkAllGroup = [];
            item.functions.map((val, key) => {
              let functionsIndex = data.functions[item.name].functions.indexOf(
                val.name
              );
              val.status = false;
              if (functionsIndex >= 0) {
                a.push(val.nameString);
                item.checkAll = false;
              } else {
                item.checkAllGroup.push(val.nameString);
                val.status = true;
              }
            });
            if (!item.checkAllGroup.length) {
              item.indeterminate = false;
              item.checkAll = false;
              item.checkAllGroup = [];
            } else if (item.checkAllGroup.length === item.functions.length) {
              item.indeterminate = false;
              item.checkAll = true;
            }
          }
        });
        this.PageData = pages;
      });
    },
    handleCheckAll(e) {
      console.log(e);
      if (this.PageData[e].indeterminate) {
        this.PageData[e].checkAll = false;
      } else {
        this.PageData[e].checkAll = !this.PageData[e].checkAll;
      }
      this.PageData[e].indeterminate = false;

      if (this.PageData[e].checkAll) {
        this.PageData[e].disabled = false;
        let arr = [];
        this.PageData[e].functions.map((item) => {
          arr.push(item.nameString);
          item.status = true;
        });
        this.PageData[e].checkAllGroup = arr;
      } else {
        this.PageData[e].checkAllGroup = [];
        this.PageData[e].functions.map((item) => {
          item.status = false;
        });
      }
    },
    checkAllGroupChange(data, key) {
      console.log(data, key);
      if (data.length === this.PageData[key].functions.length) {
        this.PageData[key].indeterminate = false;
        this.PageData[key].checkAll = true;
      } else if (data.length > 0) {
        this.PageData[key].indeterminate = true;
        this.PageData[key].checkAll = false;
      } else {
        this.PageData[key].indeterminate = false;
        this.PageData[key].checkAll = false;
      }
      this.PageData[key].functions.map((item) => {
        if (data.indexOf(item.nameString) >= 0) {
          item.status = true;
        } else item.status = false;
      });
    },
    save() {
      this.loading = true;
      let data = {};
      console.log(this.PageData);
      this.PageData.map((item, index) => {
        data[item.name] = {
          disabled: item.disabled,
          functions: [],
        };
        item.functions.map((val, index) => {
          if (item.disabled || !val.status) {
            data[item.name].functions.push(val.name);
          }
        });
        if (data[item.name].functions.length === item.functions.length)
          data[item.name].disabled = true;
      });
      let params = {
        functions: JSON.stringify(data),
        name: this.info.name,
      };
      if (!params.name) {
        this.loading = false;
        this.$Message.error("请输入角色名称");
        return false;
      }
      if (this.id) params.id = this.id;
      this.SaveRole(params).then((res) => {
        if (res.status) {
          this.$Message.success(res.msg);
          this.$router.back();
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    back() {
      this.$router.back();
    },
  },
};
</script>

<style lang="less" scoped>
.group {
  // border-bottom: 1px solid #e9e9e9;
  padding-bottom: 6px;
  margin-bottom: 6px;
}
.line {
  margin: 20px 0;
  border-bottom: 1px solid #e9e9e9;
}
.col {
  margin-right: 10px;
  width: 100%;
}
.ivu-col {
  float: left;
}
.left {
  font-size: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 15px 20px;
  color: black;
  padding-bottom: 9px;
  border-bottom: 1px solid #ddd;
  .right {
    display: inline-block;
  }
}
</style>
